import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { getStripe, getStripeEnvironment } from "@/lib/stripe";
import {
  createShopCheckoutSession,
  type ShopCheckoutItem,
} from "@/utils/payments.functions";

export type ShopCheckoutCustomer = {
  customerName: string;
  customerEmail: string;
  customerPhone?: string;
  street?: string;
  city: string;
  state: string;
  /** Texas ZIP — server re-validates it before creating a session. */
  zip?: string;
  fulfillment?: "ship" | "pickup";
  orderNotes?: string;
};

export function ShopEmbeddedCheckout({
  items,
  customer,
}: {
  items: ShopCheckoutItem[];
  customer: ShopCheckoutCustomer;
}) {
  const fetchClientSecret = async (): Promise<string> => {
    const result = await createShopCheckoutSession({
      data: {
        items,
        ...customer,
        returnUrl: `${window.location.origin}/shop/order-complete?session_id={CHECKOUT_SESSION_ID}`,
        environment: getStripeEnvironment(),
      },
    });
    if ("error" in result) throw new Error(result.error);
    if (!result.clientSecret) throw new Error("Checkout could not be started.");
    return result.clientSecret;
  };

  return (
    <div id="checkout" className="bg-white">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={{ fetchClientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
